/*
 * Krok NOC2 bod 3 (nalez N13) — JEDNA SAZBA CASTKY PRO VSECHNY OBRAZOVKY.
 *
 * Krok NOC1 sjednotil sazbu castky v TEXTU DOKUMENTU (`czechNumberText`
 * v `@reos/documents`). Nocni QA 13. 10. 2026 pak nasla tutez castku jeste
 * ve tretim tvaru: souhrn „To nejdůležitější ze smlouvy" na klientske strance
 * podpisu sazel `15.000,5 Kč` a `3.500 Kč` (tecka jako oddelovac tisicu,
 * zahozena koncova nula) — dva nezavisle `toLocaleString('cs-CZ')
 * .replace(/\s/g, '.')` v `signature/party-data.ts` a v adminu
 * (`contract-presentation.ts`). Klient tedy cetl u teze smlouvy jinou castku
 * v PDF a jinou v souhrnu nad podpisem.
 *
 * Pravidlo zije TADY, v platformni sluzbe, protoze ho potrebuji OBA bundly
 * (`@reos/documents` na serveru i `apps/web-admin` v prohlizeci) a admin
 * kontext `documents` importovat nesmi (CLAUDE.md pravidlo 4).
 *
 * Opacny smer (co clovek NAPSAL do pole → kanonicka hodnota) zustava
 * v `apps/web-admin/src/lib/czech-number.ts`: ten cte vstup, tenhle pise
 * vystup.
 */
/** Kanonicky desetinny retezec — tentyz tvar, jaky uklada API (`@reos/money`). */
const CANONICAL_NUMBER = /^-?\d+(\.\d+)?$/;
/** Oddelovac tisicu je NEZLOMITELNA mezera: „15 000" se nesmi zlomit na konci radku. */
const GROUP_SEPARATOR = ' ';
/**
 * Kanonicka castka → cesky zapis BEZ jednotky (`15000.5` → `15 000,50`).
 *
 * Cela castka jde bez desetin („15 000"), necela vzdy na dve mista
 * („15 000,50"); desetiny se NEZAOKROUHLUJI (castka ve smlouve je pravni
 * udaj). Jednotku („Kč") pise volajici — vzory smluv ji maji za tokenem.
 *
 * Co kanonicke cislo NENI, projde beze zmeny: formatovac nikdy nezahodi
 * hodnotu, kterou nezna.
 */
export function czechAmountText(value) {
    const text = value.trim();
    if (!CANONICAL_NUMBER.test(text))
        return value;
    const negative = text.startsWith('-');
    const body = negative ? text.slice(1) : text;
    const dot = body.indexOf('.');
    const whole = dot === -1 ? body : body.slice(0, dot);
    const rawFraction = (dot === -1 ? '' : body.slice(dot + 1)).replace(/0+$/, '');
    const fraction = rawFraction === '' ? '' : rawFraction.padEnd(2, '0');
    const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, GROUP_SEPARATOR);
    return `${negative ? '-' : ''}${grouped}${fraction === '' ? '' : `,${fraction}`}`;
}
/**
 * Je to kanonicka castka (`15000.5`), tedy hodnota, kterou `czechAmountText`
 * umi vysazet? Volajici podle toho pozna, ze k vysledku smi pripsat jednotku:
 * „dle dohody" neni castka a „dle dohody Kč" by bylo horsi nez puvodni text.
 */
export function isCanonicalAmount(value) {
    return CANONICAL_NUMBER.test(value.trim());
}
//# sourceMappingURL=czech-amount.js.map